export default __webpack_public_path__ + "static/media/recommendations.10a612da.svg";